import { IconButton, useTheme } from '@mui/material';
import React from 'react';
import { LuBell as NotificationsIcon } from 'react-icons/lu';

export type NotificationToggleButtonProps = {
  isNotificationPanelOpen: boolean;
  onToggle: () => void;
  className?: string;
};

/**
 * Notification Toggle Button Component
 * Handles the notification bell button with conditional visibility and animations
 */
const NotificationToggleButton = ({ isNotificationPanelOpen, onToggle, className }: NotificationToggleButtonProps) => {
  const theme = useTheme();

  // Only show when notification panel is closed
  if (isNotificationPanelOpen) {
    return null;
  }

  return (
    <IconButton
      color="inherit"
      aria-label="notifications"
      onClick={onToggle}
      className={className}
      sx={{
        mr: 1,
        transition: theme.transitions.create(['opacity', 'transform'], {
          duration: theme.transitions.duration.short
        }),
        '&:hover': {
          backgroundColor: 'action.hover',
          transform: 'scale(1.1)'
        },
        '&:active': {
          transform: 'scale(0.95)'
        }
      }}
    >
      <NotificationsIcon />
    </IconButton>
  );
};

export default NotificationToggleButton;
